var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7116 26.2961L13.7116 26.2961L18.354 24.4519C18.6396 24.3385 18.8281 24.0665 18.8281 23.7625V18.0787L28.2332 6.16202C29.6977 6.11399 30.8775 4.93575 30.8775 3.48934C30.8775 2.01236 29.6474 0.815039 28.1403 0.815039H3.35412C1.84694 0.815039 0.616797 2.01235 0.616797 3.48934C0.616797 4.93582 1.79671 6.11399 3.26111 6.16208L12.6662 18.0787V25.6067C12.6662 25.8554 12.793 26.0868 13.0028 26.2246L13.0577 26.141L13.0028 26.2246C13.1299 26.3081 13.2776 26.3507 13.4261 26.3507C13.5226 26.3507 13.6196 26.3326 13.7116 26.2961ZM17.3086 18.5687V23.2614L14.1858 24.502V18.5687H17.3086ZM28.1403 4.67559H18.7297C18.3123 4.67559 17.9699 5.00641 17.9699 5.41959C17.9699 5.83276 18.3124 6.16358 18.7297 6.16358H26.3115L17.6953 17.0807H13.7991L5.18278 6.16358H12.7647C13.182 6.16358 13.5244 5.83276 13.5244 5.41959C13.5244 5.00641 13.182 4.67559 12.7647 4.67559H3.35412C2.68039 4.67559 2.13631 4.14108 2.13631 3.48928C2.13631 2.83754 2.68039 2.30303 3.35412 2.30303H28.1403C28.814 2.30303 29.3581 2.83754 29.3581 3.48934C29.358 4.14108 28.8139 4.67559 28.1403 4.67559Z",
    fill: "#412A7C",
    stroke: "#412A7C",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.4ff3672dfab191477595ca4d437589d4.svg";
export { ForwardRef as ReactComponent };